<template>
  <form>
    <nav-tabs-card>
      <template slot="content">
        <md-tabs class="md-success" md-alignment="centered">
          <md-tab
            id="tab-logs"
            md-label="Logs"
            md-icon="view_list"
            style="overflow: auto;height: 380px"
          >
            <md-progress-spinner
              v-if="table_spinner"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <md-table
              v-show="!table_spinner"
              v-model="application_logs"
              table-header-color="green"
            >
              <md-table-empty-state
                md-label="No application log found"
                :md-description="`No application log found for this student.`"
              >
              </md-table-empty-state>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="User"
                  >{{ item.user.first_name }} {{ item.user.last_name }}
                </md-table-cell>
                <md-table-cell md-label="Status">{{ item.log }}</md-table-cell>
                <md-table-cell
                  v-if="item.message !== 'null' || !item.message"
                  md-label="Message"
                >
                  {{ item.message }}
                </md-table-cell>
                <md-table-cell v-else md-label="Message"></md-table-cell>
                <md-table-cell md-label="Created date">{{
                  item.created_date
                }}</md-table-cell>
                <md-table-cell md-label="File" style="width: 2%">
                  <md-button
                    v-if="item.file"
                    class="md-just-icon md-primary md-round"
                    :href="item.file"
                    target="_blank"
                  >
                    <md-icon>cloud_download</md-icon>
                    <md-tooltip md-direction="bottom">Detail</md-tooltip>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-tab>

          <md-tab
            id="tab-files"
            md-label="Files"
            md-icon="description"
            style="overflow: auto;height: 380px"
            @click="filesTabTrigger"
          >
            <md-progress-spinner
              v-if="table_spinner"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <md-table
              v-show="!table_spinner"
              v-model="application_files"
              table-header-color="green"
            >
              <md-table-empty-state
                md-label="No application file found"
                :md-description="`No application file found for this student.`"
              >
              </md-table-empty-state>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Type">{{
                  item.file_type
                }}</md-table-cell>
                <md-table-cell md-label="Created date">{{
                  item.created_date
                }}</md-table-cell>
                <md-table-cell md-label="File" style="width: 2%">
                  <md-button
                    v-if="item.file"
                    class="md-just-icon md-primary md-round"
                    :href="item.file"
                    target="_blank"
                  >
                    <md-icon>cloud_download</md-icon>
                    <md-tooltip md-direction="bottom">Detail</md-tooltip>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-tab>

          <md-tab
            id="tab-notes"
            md-label="Notes"
            md-icon="bookmark"
            style="overflow: auto;height: 380px"
          >
            <md-progress-spinner
              v-if="table_spinner"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <md-table
              v-show="!table_spinner"
              v-model="application_notes"
              table-header-color="green"
            >
              <md-table-empty-state
                md-label="No application notes found"
                :md-description="`No application notes found for this student.`"
              >
              </md-table-empty-state>
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Type">{{
                  item.file_type
                }}</md-table-cell>
                <md-table-cell md-label="Created date">{{
                  item.created_date
                }}</md-table-cell>
                <md-table-cell md-label="File" style="width: 2%">
                  <md-button
                    v-if="item.file"
                    class="md-just-icon md-primary md-round"
                    :href="item.file"
                    target="_blank"
                  >
                    <md-icon>cloud_download</md-icon>
                    <md-tooltip md-direction="bottom">Detail</md-tooltip>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-tab>
        </md-tabs>
      </template>
    </nav-tabs-card>
  </form>
</template>
<script>
import { NavTabsCard } from "@/components";

export default {
  components: {
    NavTabsCard
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      applicationID: null,
      application_files: [],
      application_logs: [],
      application_notes: [],
      table_spinner: true
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    filesTabTrigger() {
      if (!this.application_files.length) {
        this.getFiles();
      }
    },
    getFiles() {
      this.$store
        .getApplicationFiles(this.applicationID)
        .then(response => {
          this.application_files = response.data;
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    getLogs() {
      this.$store
        .getApplicationLogs(this.applicationID)
        .then(response => {
          this.application_logs = response.data;
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.applicationID = this.$route.params.application_id;
    this.getLogs();
  }
};
</script>
<style>
body
  > div
  > div.main-panel
  > div.content
  > div
  > div:nth-child(3)
  > form:nth-child(1)
  > div
  > div
  > div
  > div.md-tabs-navigation.md-elevation-0 {
  padding: 15px 0 15px 0;
}
</style>
